<template>
    <button 
        type="button" 
        :class="setTheme[theme]" 
        @click="handleClick" 
        class="flex items-center">
        <div class="flex items-center justify-center w-full">
            <template v-if="button_loading">
                <span class="loader"></span>
            </template>
            <template v-else>
                <IconControl 
                    class="mr-5" 
                    v-if="icon_id && icon_width && icon_height" 
                    :id="icon_id" 
                    :width="icon_width" 
                    :height="icon_height" 
                />
                <span>{{ text }}</span>
                <slot></slot>
            </template>
        </div>
    </button>
</template>

<script>
import IconControl from './IconControl.vue';
import mixin from '@/mixins/controls.js';

export default {
    name: 'v-button',
    mixins: [mixin],
    components: {
        IconControl
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        button_loading: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'success',
        },
        text: {
            type: String,
            required: true,
            default: 'Button'
        },
        icon_id: {
            type: String,
        },
        icon_width: {
            type: Number,
        },
        icon_height: {
            type: Number,
        },
    },
    computed: {
        setTheme() {
            const base_style = 'font-semibold uppercase my-10 p-5 px-10 rounded-xl flex flex-row text-5xl justify-center focus:outline-none';
            const del_clr_style = 'font-bold m-2 uppercase rounded-lg border border-1 text-white justify-center focus:outline-none papsi-del-clr';
            const loading_style = 'cursor-not-allowed pointer-events-none';
            return {
                success: this.disabled || this.button_loading ? `bg-grey text-white ${loading_style} ${base_style}` : `bg-primary text-white ${base_style}`,
                error: this.disabled || this.button_loading ? `bg-grey text-white ${loading_style} ${base_style}` : `bg-error text-white ${base_style}`,
                info: this.disabled || this.button_loading ? `bg-grey text-white ${loading_style} ${base_style}` : `bg-info text-white ${base_style}`,
                warning: this.disabled || this.button_loading ? `bg-grey text-white ${loading_style} ${base_style}` : `bg-warning text-white ${base_style}`,
                warning_secondary: this.disabled || this.button_loading ? `bg-grey text-white ${loading_style} ${base_style}` : `bg-white border-4 border-warning text-warning ${base_style}`,
                neutral: this.disabled || this.button_loading ? `bg-grey text-white ${loading_style} ${base_style}` : `bg-grey-lighter text-grey-darkest ${base_style}`,
                keypad: 'bg-grey-lighter text-black font-bold m-2 rounded-lg border border-1 justify-center text-5xl focus:outline-none papsi-keypad',
                delete: `bg-error ${del_clr_style} text-3xl`,
                clear: `bg-warning ${del_clr_style} text-3xl`,
                pagination: `bg-white text-primary  font-bold text-2xl w-16 h-16 flex items-center justify-center rounded-full focus:outline-none`,
                current_page: `bg-primary text-white border border-primary font-bold text-2xl w-16 h-16 flex items-center justify-center rounded-full focus:outline-none active-btn`,
                service: `bg-primary-light text-primary text-5xl font-bold rounded-xl text flex flex-row p-10 focus:outline-none`,
                back: `bg-grey-lighter text-grey-darker text-4xl px-6 py-4 font-bold uppercase rounded-xl text flex flex-row focus:outline-none`,
                no: `bg-grey-lighter text-grey-darkest text-4xl px-6 py-4 font-bold uppercase rounded-xl text flex flex-row focus:outline-none`,
                login: `bg-info text-white text-4xl px-6 py-4 font-bold uppercase rounded-xl text flex flex-row focus:outline-none`,
                logout: `bg-red-lighter text-red-darker text-4xl px-6 py-4 font-bold uppercase rounded-xl text flex flex-row focus:outline-none`,
                summary: `font-semibold uppercase p-3 px-10 rounded-xl flex flex-row text-3xl justify-center bg-primary text-white focus:outline-none`,
            };
        }
    },
};
</script>

<style scoped>
.loader {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: block;
  margin:15px auto;
  position: relative;
  color: #FFF;
  box-sizing: border-box;
  animation: animloader 2s linear infinite;
}

@keyframes animloader {
  0% {
    box-shadow: 14px 0 0 -2px,  38px 0 0 -2px,  -14px 0 0 -2px,  -38px 0 0 -2px;
  }
  25% {
    box-shadow: 14px 0 0 -2px,  38px 0 0 -2px,  -14px 0 0 -2px,  -38px 0 0 2px;
  }
  50% {
    box-shadow: 14px 0 0 -2px,  38px 0 0 -2px,  -14px 0 0 2px,  -38px 0 0 -2px;
  }
  75% {
    box-shadow: 14px 0 0 2px,  38px 0 0 -2px,  -14px 0 0 -2px,  -38px 0 0 -2px;
  }
  100% {
    box-shadow: 14px 0 0 -2px,  38px 0 0 2px,  -14px 0 0 -2px,  -38px 0 0 -2px;
  }
}

@media only screen and (min-width: 2500px) {
    .papsi-del-clr {
        width: 60rem !important;
        height: 8rem !important;
        border-radius: 1rem;
    }

    button {
        border-radius: 1rem;
    }

    .active-btn {
        border-radius: 100%;
    }
    
}

</style>
